// GETS THE CAROUSEL SLIDER MEDIA HEIGHT USED TO ALIGN CAROUSEL SLIDER BUTTON VERTICALLY CENTER TO MEDIA

window.addEventListener('DOMContentLoaded', function(){
    const slider = this.document.querySelector('carousel-slider');
    const mediaElementHeight = slider.querySelector('.card__media').getBoundingClientRect().height;
    slider.setAttribute('style', `--mediaHeight:${mediaElementHeight}px;`)
})